import request from '@/common/request'

class VinculadorService {
  getAll(params) {
    return request.get('/vinculos/itens', {
      params
    })
  }

  criarSugestao(precisao) {
    return request.post('/vinculos/itens?precisao=' + precisao)
  }

  addExcecaoSugestao(itemClienteId, itemVoId) {
    return request.post('/vinculos/excecoes', {
      itemClienteId,
      itemVoId
    })
  }

  removerItemSugestao(itemClienteId, itemVoId) {
    return request.delete('/vinculos/itens/' + itemClienteId + '/itemvo/' + itemVoId)
  }
}

export default new VinculadorService()
